import {
  ACCESS_TOKEN_NAME,
  FORM_DATA_CONTENT_TYPE,
} from '../constant/constants';
import { IApiParams } from '../interface/IApiParams';
import { getCookie, secureToken } from '../utils/utils';
import { getApi } from './getApi';

export const apiDeleteFile = async (
  type: number,
  section: string,
  route: string,
  page: string,
  name: string
) => {
  const params: IApiParams = {
    url: `/admin/deleteFile.php?section=${section}&route=${route}&page=${page}&type=${type}&name=${name}&${secureToken()}`,
    headers: {
      'Content-Type': FORM_DATA_CONTENT_TYPE,
      'Access-Token': getCookie(ACCESS_TOKEN_NAME),
    },
  };
  return getApi(params, 'GET');
};
